<div class="card monsido-panel mt-3 mx-3">
  <div class="card-header">
    <h3 class="font-weight-300">Importing Checks</h3>
  </div>
  <div class="card-body">
    <p class="step-description">Please wait while we update the accessibility checks...</p>

    <div class="progress-section">
      <div class="progress-stats">
        <div class="stat-item">
          <span class="stat-label">Progress:</span>
          <span class="stat-value">{{ currentRow }} / {{ totalRows }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Success:</span>
          <span class="stat-value text-success">{{ successful }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Failed:</span>
          <span class="stat-value text-danger">{{ failed }}</span>
        </div>
      </div>

      <div class="progress-bar-container">
        <div class="progress">
          <div 
            class="progress-bar"
            [ngClass]="{
              'progress-bar-striped': isImporting,
              'progress-bar-animated': isImporting,
              'bg-info': getProgressBarColor() === 'info',
              'bg-primary': getProgressBarColor() === 'primary',
              'bg-warning': getProgressBarColor() === 'warning',
              'bg-success': getProgressBarColor() === 'success'
            }"
            role="progressbar"
            [style.width.%]="getProgressPercentage()"
            [attr.aria-valuenow]="currentRow"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="totalRows">
            {{ getProgressPercentage() }}%
          </div>
        </div>
        <div class="progress-message">{{ currentMessage }}</div>
      </div>

      @if (isImporting) {
        <div class="cancel-section">
          <button type="button" class="btn btn-danger" (click)="cancelImport()">
            Cancel Import
          </button>
        </div>
      }
    </div>
  </div>
</div>
